export const RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL =
	'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';
